

















module.exports =
  name: 'updated_accounts'
  components:
    balance: require('components/inside/elements/balance.vue').default
  data: -> { changes: [] }
  mounted: ->
    @changes = HM.store.state.ui.accounts_virtuals_changed_tooltip # @$store недоступна
